var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7.65a.65.65 0 0 1 0-1.3h10a.65.65 0 0 1 .65.65v10a.65.65 0 1 1-1.3 0V8.57l-8.89 8.89a.65.65 0 1 1-.92-.92l8.89-8.89H7Z",
    fill: "currentColor"
  })));
};

export { Svg24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03IDcuNjVDNi42NDEwMiA3LjY1IDYuMzUgNy4zNTg5OSA2LjM1IDdDNi4zNSA2LjY0MTAyIDYuNjQxMDIgNi4zNSA3IDYuMzVIMTdDMTcuMzU5IDYuMzUgMTcuNjUgNi42NDEwMiAxNy42NSA3VjE3QzE3LjY1IDE3LjM1OSAxNy4zNTkgMTcuNjUgMTcgMTcuNjVDMTYuNjQxIDE3LjY1IDE2LjM1IDE3LjM1OSAxNi4zNSAxN1Y4LjU2OTI0TDcuNDU5NjIgMTcuNDU5NkM3LjIwNTc4IDE3LjcxMzUgNi43OTQyMiAxNy43MTM1IDYuNTQwMzggMTcuNDU5NkM2LjI4NjU0IDE3LjIwNTggNi4yODY1NCAxNi43OTQyIDYuNTQwMzggMTYuNTQwNEwxNS40MzA4IDcuNjVIN1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";